/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listNotifications.defs.js'
export * as $defs from './listNotifications.defs.js'
